import { InteractiveTable, InteractiveTableCellProps, Text } from '@dreryk/react-components';

import { MedicalServicePractitionerTaxRate } from '../../practitioner.types';

type MedicalServicePractitionerTaxRateCellProps = InteractiveTableCellProps<MedicalServicePractitionerTaxRate> & {
   readonly defaultValue: MedicalServicePractitionerTaxRate;
};

export const MedicalServicePractitionerTaxRateCell = (
   props: MedicalServicePractitionerTaxRateCellProps
): JSX.Element => {
   return (
      <InteractiveTable.CustomCell<MedicalServicePractitionerTaxRate>
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
      >
         {(taxRate) => {
            return <Text testId={'taxRate'}>{taxRate.name}</Text>;
         }}
      </InteractiveTable.CustomCell>
   );
};
